<template>
    <span :class="statusSpecificConfig.class">
        <i :class="statusSpecificConfig.icon"></i> {{ statusSpecificConfig.text }}
    </span>
</template>

<script>

import {PaymentStatuses} from "../../../config";

export default {
    name: 'PaymentStatusLabel',

    props: {
        paymentStatus: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            config: {
                [PaymentStatuses.PAYMENT_STATUS_PAID]: {
                    class: 'text-success',
                    icon: 'fa fa-check-circle',
                    text: 'Paid',
                },
                [PaymentStatuses.PAYMENT_STATUS_UNPAID]: {
                    class: 'text-warning',
                    icon: '',
                    text: '',
                },
                [PaymentStatuses.PAYMENT_STATUS_REQUIRES_ACTION]: {
                    class: 'text-danger',
                    icon: 'fa fa-exclamation-triangle',
                    text: 'Action Required',
                },
            },
        }
    },

    computed: {
        statusSpecificConfig() {
            return this.config[this.paymentStatus];
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Labels/PaymentStatusLabel.vue